<template>
    <ul class="filter" v-if="showFilters">
        <li class="filter__item">
            <div class="filter__item-first">{{ dictionary.ArticlesFilter }}</div>
        </li>
        <li class="filter__item">
            <div class="filter__item-container">
                <div
                    class="filter__item-item"
                    v-for="tagItem in tags"
                    :key="tagItem.Key"
                    :class="{ active: activeTags.includes(tagItem.Key) }" 
                    @click="toggleTag(tagItem.Key)" 
                >
                    {{ tagItem.Name }}
                </div>
            </div>
        </li>
    </ul>
    <ul class="articles-list__items">
        <li v-for="article in articles" :key="article.Url">
            <article class="article-item">
                <a :href="article.Url" class="article-item__link">
                    <div class="article-item__inner">
                        <div class="article-item__image">
                            <ResponsiveImage v-if="article.ImageForVue != null" :imageModel="article.ImageForVue" />
                        </div>
                        <div class="article-item__text">
                            <p class="article-item__tag" v-if="article.HasTag">{{ article.Tag }}</p>
                            <h3 class="article-item__headline">{{ article.Headline }}</h3>
                        </div>
                    </div>
                </a>
            </article>
        </li>
    </ul>
    <div class="articles-list__cta">
        <div class="articles-list__load-more" v-show="hasMoreArticles">
            <a @click="getNextPage" :disabled="isLoading">
                {{ dictionary.LoadMore }}
            </a>
        </div>
    </div>
</template>


<script>
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";

const serviceUrl = "/umbraco/api/articlesApi/getArticles";
export default {
    name: "Articles",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            tags: [],
            articles: [],
            pageSize: 9,
            totalArticles: 0,
            page: 1,
            isLoading: false,
            hasLoadedInitials: false,
            articlesNodeId: 0,
            isResetting: false,
            activeTags: [],
            showFilters: false
        };
    },
    mixins: [
        bindRoute({
            tag: [],
        }),
    ],
    watch: {
        tag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
    },
    mounted() {
        this.articlesNodeId = this.$parent.articlesNodeId;
        this.pageSize = this.$parent.pageSize;
        this.showFilters = this.$parent.showFilters === "True";

        this.$router.isReady().then(() => {
            this.getInitialArticles();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        toggleTag(tagKey) {
            if (this.activeTags.includes(tagKey)) {
                // Remove tag from activeTags if already selected
                this.activeTags = this.activeTags.filter(key => key !== tagKey);
            } else {
                // Add tag to activeTags
                this.activeTags.push(tagKey);
            }
            // Trigger filtering when tags are toggled
            this.filterChanged();
        },
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getArticles(itemsToSkip, pageSize, showFilters) {
            const vm = this,
            cultureCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                articlesNodeId: vm.articlesNodeId,
                cultureCode: cultureCode,
                itemsToSkip: itemsToSkip,
                pageSize: pageSize,
                showFilters: showFilters
            };

            if (vm.activeTags.length > 0) {
                object.tag = vm.activeTags;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.articles.push(...data.Items);
                    vm.tags = data.Facets.Tags;
                    vm.dictionary = data.Dictionary;
                    vm.totalArticles = data.TotalItems;
                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getArticles(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialArticles() {
            // Get all cases up to, and including, the current page
            const initialPageSize = this.pageSize * this.page;
            this.getArticles(0, initialPageSize);
        },
        filterChanged() {
            this.articles = [];
            this.totalArticles = 0;
            this.page = 1;
            this.getArticles(0, this.pageSize);
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.articles = [];
            vm.totalArticles = 0;
            vm.page = 1;
            vm.tag = [];

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getArticles(0, vm.pageSize);
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreArticles() {
            return (
                this.totalArticles !== 0 &&
                this.articles.length < this.totalArticles
            );
        },
        hasFilterApplied() {
            return this.activeTags.length > 0;
        }
    },
};
</script>